import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './CSS/Register.css';
import { useLanguage } from '../Context/LanguageContext'; // Import the context

const Register = () => {
  const { t } = useLanguage(); // Access translations
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://weynibirhan.com.et/register.php', {
        username,
        email,
        password,
      });

      const data = response.data;
      setMessage(data.message || t.register_failed);
    } catch (error) {
      setMessage(t.register_failed);
    }
  };

  return (
    <div className="register-container">
      <div className="register-form">
        <h2>{t.register_title}</h2>
        <form onSubmit={handleRegister}>
          <input
            type="text"
            placeholder={t.register_username}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="email"
            placeholder={t.register_email}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder={t.register_password}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">{t.register_button}</button>
        </form>
        {message && <p>{message}</p>}
        <p>
          {t.register_have_account} <Link to="/login">{t.register_login_here}</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
